export default __webpack_public_path__ + "static/media/plus.18ad19d8.svg";